// extracted by mini-css-extract-plugin
module.exports = {"container":"_2TZ0RKnEMaCq56W7Q_yyv","cancelBtn":"_1fibLM1jG7TEQSqab1h7a9","icon":"GuVjd7JcBaPKPveagToi1","saveBtn":"jDBFgJVkEJKY2nvrwnXIe"};